<template>
  <BaseVeeForm :action="submitForm" ensure-error-keys-camel-case>
    <template #default="formProps">
      <div class="bg-gray-50 flex items-start">
        <div class="flex-1 px-6 py-4">
          <ValidationProvider rules="required" name="name" slim vid="name">
            <template #default="{ errors }">
              <BaseFormGroup>
                <BaseFormInput type="text" v-model="formData.name" :disabled="disabled" />
                <BaseFormInlineMessage v-if="errors.length" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>
        </div>
        <div class="w-64 px-6 py-4">
          <ValidationProvider rules="required" name="document type" slim vid="document_type">
            <template #default="{ errors }">
              <BaseFormGroup>
                <BaseFormSelect
                  v-model="formData.documentType"
                  :options="documentTypeOptions"
                  :disabled="disabled"
                  required
                  class="w-full"
                />
                <BaseFormInlineMessage v-if="errors.length" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>
        </div>
        <div class="w-40 px-6 py-4">
          <ValidationProvider rules="required" name="number" slim vid="number">
            <template #default="{ errors }">
              <BaseFormGroup>
                <BaseFormInput type="text" v-model="formData.number" :disabled="disabled" />
                <BaseFormInlineMessage v-if="errors.length" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>
        </div>
        <div class="w-40 px-6 py-4">
          <ValidationProvider name="follows" slim vid="follows">
            <template #default="{ errors }">
              <BaseFormGroup>
                <BaseFormInput type="text" v-model="formData.follows" :disabled="disabled" />
                <BaseFormInlineMessage v-if="errors.length" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>
        </div>
        <div class="w-40 px-6 py-4">
          <button
            type="submit"
            class="w-full inline-flex items-center px-4 py-2 border text-sm justify-center font-medium rounded-md bg-white focus:outline-none disabled:border-transparent disabled:text-gray-500 border-gray-300 text-gray-700 hover:bg-gray-50 focus:border-blue-600"
            :disabled="disabled || formProps.isPending || formProps.invalid"
          >
            Create
          </button>
        </div>
      </div>
    </template>
  </BaseVeeForm>
</template>

<script>
import { softOneApiServiceConfigDocumentTypesClient } from '@/api/clients';

const defaultFormData = {
  name: '',
  documentType: '',
  number: '',
  follows: '',
};

export default {
  props: {
    softOneServiceId: {
      type: String,
      required: true,
    },
    disabled: Boolean,
  },
  data() {
    return {
      formData: {
        ...defaultFormData,
      },
      documentTypeOptions: [
        { value: 'orders', label: 'Orders' },
        { value: 'credit notes', label: 'Credit notes' },
      ],
    };
  },
  methods: {
    async submitForm() {
      try {
        await this.$store.dispatch('ui/thirdPartyServices/updateFromService', {
          id: this.softOneServiceId,
          formData: { ...this.formData },
          service: softOneApiServiceConfigDocumentTypesClient.store,
        });

        // this.formData = { ...defaultFormData };

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
